import cn from 'classnames';

import styles from './AppContainer.module.scss';

type IAppContainerProps = {
  dataQa?: string;
  hidePaddings?: boolean;
};

export const AppContainer: FC<IAppContainerProps> = ({ hidePaddings, className, children, dataQa }) => {
  return (
    <div
      data-qa={dataQa}
      className={cn(styles.container, className, {
        [styles.containerMobileNoPadding]: hidePaddings,
      })}
    >
      {children}
    </div>
  );
};
